export enum OnHoldTabStatus {
    EnAttente = 701,
    Code3 = 3,
    Code9 = 9,
    Code17 = 17,
    Code19 = 19,
    Code41 = 41,
    Code47 = 47,
    Code90 = 90,
    NatFlex = 707,
    Manifest = 714,
}
